import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "apartment-table" }
const _hoisted_2 = { class: "apartment-table-filters" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "legend" }, " Klatka: ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Dowolna", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "A" }, "A", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "B" }, "B", -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "legend" }, " Piętro: ", -1)
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "legend" }, " Powierzchnia: ", -1)
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "legend" }, " Pokoje: ", -1)
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "legend" }, " Tylko dostępne: ", -1)
const _hoisted_17 = { class: "stats" }
const _hoisted_18 = { class: "dir-legend" }
const _hoisted_19 = { class: "table" }
const _hoisted_20 = { id: "klatka" }
const _hoisted_21 = { id: "mieszkanie" }
const _hoisted_22 = { id: "kondygnacja" }
const _hoisted_23 = { id: "powierzchnia" }
const _hoisted_24 = { id: "pomieszczenia" }
const _hoisted_25 = { id: "balkony" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", { id: "kierunek" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Kierunek ")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", { id: "rzut" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Rzut ")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", { id: "cena" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Status ")
], -1)
const _hoisted_29 = ["title"]
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = ["href"]
const _hoisted_34 = { class: "mobile-table" }
const _hoisted_35 = { class: "mobile-table" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      colspan: "2",
      class: "divider"
    })
  ])
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("span", null, " Kierunek ")
], -1)
const _hoisted_38 = ["title"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("span", null, " Rzut ")
], -1)
const _hoisted_40 = ["href"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_43 = ["href"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    class: "divider"
  })
], -1)
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_clear_button = _resolveComponent("clear-button")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_sort_buttons = _resolveComponent("sort-buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.apartments)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, [
              _hoisted_4,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.klatka) = $event))
              }, _hoisted_8, 512), [
                [_vModelSelect, _ctx.filter.klatka]
              ]),
              _createVNode(_component_clear_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.klatka = null))
              })
            ]),
            _createElementVNode("p", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_Slider, {
                class: "slider",
                modelValue: _ctx.filter.kondygnacja,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.kondygnacja) = $event)),
                min: _ctx.$options.Validation.MIN_KONDYGNACJA,
                max: _ctx.$options.Validation.MAX_KONDYGNACJA,
                step: 1,
                merge: _ctx.$options.Validation.MAX_KONDYGNACJA,
                tooltips: true
              }, null, 8, ["modelValue", "min", "max", "merge"]),
              _createVNode(_component_clear_button, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.kondygnacja = [ _ctx.$options.Validation.MIN_KONDYGNACJA, _ctx.$options.Validation.MAX_KONDYGNACJA ]))
              })
            ]),
            _createElementVNode("p", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_Slider, {
                class: "slider",
                modelValue: _ctx.filter.powierzchnia,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter.powierzchnia) = $event)),
                min: _ctx.$options.Validation.MIN_POWIERZCHNIA,
                max: _ctx.$options.Validation.MAX_POWIERZCHNIA,
                step: _ctx.$options.Validation.POWIERZCHNIA_STEP,
                merge: _ctx.$options.Validation.MAX_POWIERZCHNIA,
                format: { suffix: ' m²' },
                tooltips: true
              }, null, 8, ["modelValue", "min", "max", "step", "merge"]),
              _createVNode(_component_clear_button, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter.powierzchnia = [ _ctx.$options.Validation.MIN_POWIERZCHNIA, _ctx.$options.Validation.MAX_POWIERZCHNIA ]))
              })
            ]),
            _createElementVNode("p", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_Slider, {
                class: "slider",
                modelValue: _ctx.filter.pokoje,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filter.pokoje) = $event)),
                min: _ctx.$options.Validation.MIN_POKOJE,
                max: _ctx.$options.Validation.MAX_POKOJE,
                step: 1,
                merge: _ctx.$options.Validation.MAX_POKOJE,
                tooltips: true
              }, null, 8, ["modelValue", "min", "max", "merge"]),
              _createVNode(_component_clear_button, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filter.pokoje = [ _ctx.$options.Validation.MIN_POKOJE, _ctx.$options.Validation.MAX_POKOJE ]))
              })
            ]),
            _createElementVNode("p", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_Toggle, {
                class: "toggle",
                modelValue: _ctx.filter.tylkoDostepne,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filter.tylkoDostepne) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("p", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.filteredApartments.length) + " / " + _toDisplayString(_ctx.apartments.length) + " mieszkań", 1),
            _withDirectives(_createElementVNode("span", null, ", z czego dostępnych " + _toDisplayString(_ctx.availableCount), 513), [
              [_vShow, _ctx.filteredApartments.length]
            ]),
            _createTextVNode(". ")
          ]),
          _createElementVNode("p", _hoisted_18, _toDisplayString(Object.keys(_ctx.$options.DirectionToTip).map((dir) => `${dir}: ${_ctx.$options.DirectionToTip[dir]}`).join(', ')), 1),
          _withDirectives(_createElementVNode("table", _hoisted_19, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_20, [
                  _createElementVNode("span", null, [
                    _createTextVNode(" Klatka "),
                    _createVNode(_component_sort_buttons, {
                      onSort: _cache[9] || (_cache[9] = ($direction) => _ctx.onSort('klatka', $direction))
                    })
                  ])
                ]),
                _createElementVNode("th", _hoisted_21, [
                  _createElementVNode("span", null, [
                    _createTextVNode(" Lokal "),
                    _createVNode(_component_sort_buttons, {
                      onSort: _cache[10] || (_cache[10] = ($direction) => _ctx.onSort('mieszkanie', $direction))
                    })
                  ])
                ]),
                _createElementVNode("th", _hoisted_22, [
                  _createElementVNode("span", null, [
                    _createTextVNode(" Piętro "),
                    _createVNode(_component_sort_buttons, {
                      onSort: _cache[11] || (_cache[11] = ($direction) => _ctx.onSort('kondygnacja', $direction))
                    })
                  ])
                ]),
                _createElementVNode("th", _hoisted_23, [
                  _createElementVNode("span", null, [
                    _createTextVNode(" Powierzchnia "),
                    _createVNode(_component_sort_buttons, {
                      onSort: _cache[12] || (_cache[12] = ($direction) => _ctx.onSort('powierzchnia', $direction))
                    })
                  ])
                ]),
                _createElementVNode("th", _hoisted_24, [
                  _createElementVNode("span", null, [
                    _createTextVNode(" Pokoje "),
                    _createVNode(_component_sort_buttons, {
                      onSort: _cache[13] || (_cache[13] = ($direction) => _ctx.onSort('pomieszczenia', $direction))
                    })
                  ])
                ]),
                _createElementVNode("th", _hoisted_25, [
                  _createElementVNode("span", null, [
                    _createTextVNode(" Balkon / taras "),
                    _createVNode(_component_sort_buttons, {
                      onSort: _cache[14] || (_cache[14] = ($direction) => _ctx.onSort('balkony', $direction))
                    })
                  ])
                ]),
                _hoisted_26,
                _hoisted_27,
                _hoisted_28
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredApartments, (apartment) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `apt_${apartment.mieszkanie}`,
                  class: _normalizeClass({ [apartment.status]: apartment.status })
                }, [
                  _createElementVNode("td", null, _toDisplayString(apartment.klatka), 1),
                  _createElementVNode("td", null, _toDisplayString(apartment.mieszkanie), 1),
                  _createElementVNode("td", null, _toDisplayString(apartment.kondygnacja ? apartment.kondygnacja : 'parter'), 1),
                  _createElementVNode("td", null, _toDisplayString(String(apartment.powierzchnia).replace('.', ',')) + " m²", 1),
                  _createElementVNode("td", null, _toDisplayString(apartment.pomieszczenia.filter((pom) => pom.pomieszczenie.startsWith('pokój')).length), 1),
                  _createElementVNode("td", null, [
                    (!apartment.balkony && !apartment.tarasy)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" - ")
                        ], 64))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apartment.balkony, (balcony, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "balcony",
                        key: `bl_${index}`
                      }, " balkon " + _toDisplayString(String(balcony).replace('.', ',')) + " m² ", 1))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apartment.tarasy, (terrace, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "balcony",
                        key: `tr_${index}`
                      }, " taras " + _toDisplayString(String(terrace).replace('.', ',')) + " m² ", 1))
                    }), 128))
                  ]),
                  _createElementVNode("td", {
                    title: _ctx.directionTip(apartment.wystawa)
                  }, _toDisplayString(apartment.wystawa), 9, _hoisted_29),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      target: "_blank",
                      href: `/wp-content/uploads/2022/01/karty-lokali-${apartment.mieszkanie}.pdf`
                    }, [
                      _hoisted_31,
                      _createTextVNode(" Rzut ")
                    ], 8, _hoisted_30)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass({ 'coral': apartment.status === _ctx.$options.ApartmentStatus.WOLNE })
                    }, _toDisplayString(apartment.status), 3),
                    (apartment.status !== _ctx.$options.ApartmentStatus.SPRZEDANE)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_32,
                          (!apartment.cena)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: `/kontakt?mieszkanie=${apartment.mieszkanie}`
                              }, " Spytaj o cenę ", 8, _hoisted_33))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(apartment.cena), 1)
                              ], 64))
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ])
          ], 512), [
            [_vShow, !_ctx.mobileScreen]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_34, [
            _createElementVNode("table", _hoisted_35, [
              _hoisted_36,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredApartments, (apartment) => {
                return (_openBlock(), _createElementBlock("tbody", {
                  key: `apt_${apartment.mieszkanie}`
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, [
                      _createElementVNode("span", null, [
                        _createTextVNode(" Klatka "),
                        _createVNode(_component_sort_buttons, {
                          onSort: _cache[15] || (_cache[15] = ($direction) => _ctx.onSort('klatka', $direction))
                        })
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(apartment.klatka), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, [
                      _createElementVNode("span", null, [
                        _createTextVNode(" Mieszkanie "),
                        _createVNode(_component_sort_buttons, {
                          onSort: _cache[16] || (_cache[16] = ($direction) => _ctx.onSort('mieszkanie', $direction))
                        })
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(apartment.mieszkanie), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, [
                      _createElementVNode("span", null, [
                        _createTextVNode(" Piętro "),
                        _createVNode(_component_sort_buttons, {
                          onSort: _cache[17] || (_cache[17] = ($direction) => _ctx.onSort('kondygnacja', $direction))
                        })
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(apartment.kondygnacja ? apartment.kondygnacja : 'parter'), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, [
                      _createElementVNode("span", null, [
                        _createTextVNode(" Powierzchnia "),
                        _createVNode(_component_sort_buttons, {
                          onSort: _cache[18] || (_cache[18] = ($direction) => _ctx.onSort('powierzchnia', $direction))
                        })
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(String(apartment.powierzchnia).replace('.', ',')) + " m²", 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, [
                      _createElementVNode("span", null, [
                        _createTextVNode(" Pokoje "),
                        _createVNode(_component_sort_buttons, {
                          onSort: _cache[19] || (_cache[19] = ($direction) => _ctx.onSort('pomieszczenia', $direction))
                        })
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(apartment.pomieszczenia.filter((pom) => pom.pomieszczenie.startsWith('pokój')).length), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, [
                      _createElementVNode("span", null, [
                        _createTextVNode(" Balkon / taras "),
                        _createVNode(_component_sort_buttons, {
                          onSort: _cache[20] || (_cache[20] = ($direction) => _ctx.onSort('balkony', $direction))
                        })
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      (!apartment.balkony && !apartment.tarasy)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" - ")
                          ], 64))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apartment.balkony, (balcony, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "balcony",
                          key: `bl_${index}`
                        }, " balkon " + _toDisplayString(String(balcony).replace('.', ',')) + " m² ", 1))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apartment.tarasy, (terrace, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "balcony",
                          key: `tr_${index}`
                        }, " taras " + _toDisplayString(String(terrace).replace('.', ',')) + " m² ", 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_37,
                    _createElementVNode("td", {
                      title: _ctx.directionTip(apartment.wystawa)
                    }, _toDisplayString(apartment.wystawa), 9, _hoisted_38)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_39,
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        target: "_blank",
                        href: `/wp-content/uploads/2022/01/karty-lokali-${apartment.mieszkanie}.pdf`
                      }, [
                        _hoisted_41,
                        _createTextVNode(" Rzut ")
                      ], 8, _hoisted_40)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_42,
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'coral': apartment.status === _ctx.$options.ApartmentStatus.WOLNE })
                      }, _toDisplayString(apartment.status), 3),
                      (apartment.status !== _ctx.$options.ApartmentStatus.SPRZEDANE)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" | "),
                            (!apartment.cena)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: `/kontakt?mieszkanie=${apartment.mieszkanie}`
                                }, " Spytaj o cenę ", 8, _hoisted_43))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(apartment.cena), 1)
                                ], 64))
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_44
                ]))
              }), 128))
            ])
          ], 512), [
            [_vShow, _ctx.mobileScreen]
          ])
        ], 64))
      : (_ctx.apartments == null)
        ? (_openBlock(), _createElementBlock("p", _hoisted_45, " Ładuję tabelę mieszkań... "))
        : (_openBlock(), _createElementBlock("p", _hoisted_46, " Nie udało się załadować listy lokali. Proszę spróbować później. "))
  ]))
}